const openIVM = () => {
  const url = 'https://ivm.koobits.com/dashboardv5/index.html';
  window.open(url, '_blank');
};

export default openIVM;
